export const PRIVATE_URL_PREFIX = '/private';

export type PaginatedResponse<T> = {
  result: T[];
  total: number;
};
